import { render, staticRenderFns } from "./orderLogistics.vue?vue&type=template&id=6830d70a&scoped=true"
import script from "./orderLogistics.vue?vue&type=script&lang=js"
export * from "./orderLogistics.vue?vue&type=script&lang=js"
import style0 from "./orderLogistics.vue?vue&type=style&index=0&id=6830d70a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6830d70a",
  null
  
)

export default component.exports